<div class="tt-o-modal" 
     :class="{'tt-o-modal--centered': centered}"
     @keydown.tab.stop="handleTab"
     @keydown.esc.stop="close"
     @click.stop="handleClick($event)"
     role="dialog"
     :aria-label="ariaLabel && !ariaLabeledById ? ariaLabel : undefined"
     :aria-labelledby="ariaLabeledById"
     :aria-describedby="ariaDescribedById"
     aria-modal="true"
     v-bind="$attrs">
  <tt-popover ref="popover" v-if="popoverMessage" class="tt-o-modal__popover" :autoClose="true" :message="popoverMessage" :type="popoverType" @close="closePopover"></tt-popover>
  <div ref="container" class="tt-o-modal__container" tabindex="-1">
    <div v-if="showClose" class="tt-o-modal__close">
      <tt-button ref="closeBtn" type="icon" @click.stop="close" class="tt-o-modal__close-btn" :aria-label="closeLabel" :title="closeLabel"><tt-icon name="close" size="xs"></tt-icon></tt-button>
    </div>
    <div class="tt-o-modal__body">
      <div v-if="isLoading" class="tt-o-modal__loading"><div class="tt-o-spinner"></div></div>
      <slot></slot>
    </div>
  </div>
  <slot name="externalButtons"></slot>
  <div ref="footer" class="tt-o-modal__poweredby-footer">
    <slot name="poweredByText"></slot>
  </div>
</div>
